var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sys-checkbox__container', _vm.size && ("normal-" + _vm.size)]},[_c('div',{class:[
            'sys-checkbox',
            {
                checked: _vm.value
            }
        ],on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('span',{staticClass:"sys-checkbox__icon"},[_c('CheckIcon')],1)]),(!!_vm.label)?_c('label',{staticClass:"sys-checkbox__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }